export type PlatformCounts = {
  web: number;
  android: number;
  ios: number;
};

export type PlatformUserActivity = {
  web?: string;
  android?: string;
  ios?: string;
};

export function getRangeFromSelection(selection: number) {
  const today = new Date();
  const endOfToday = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate()
  );

  if (selection === 90) {
    const currentQuarter = Math.floor(today.getMonth() / 3);
    const previousQuarter = currentQuarter === 0 ? 3 : currentQuarter - 1;
    const year =
      currentQuarter === 0 ? today.getFullYear() - 1 : today.getFullYear();

    const startDate = new Date(year, previousQuarter * 3, 1);
    const endDate = new Date(year, previousQuarter * 3 + 3, 0);

    return {
      startDate,
      endDate,
      title: "Last Quarter",
    };
  }

  if (selection === 365) {
    const year = today.getFullYear() - 1;
    return {
      startDate: new Date(year, 0, 1),
      endDate: new Date(year, 11, 31),
      title: "Last Year",
    };
  }

  return {
    startDate: new Date(
      endOfToday.getFullYear(),
      endOfToday.getMonth(),
      endOfToday.getDate() - (selection - 1)
    ),
    endDate: endOfToday,
    title: `Last ${selection} Days`,
  };
}

export function isWithinRange(
  date: Date,
  startDate: Date,
  endDate: Date
): boolean {
  const start = new Date(
    startDate.getFullYear(),
    startDate.getMonth(),
    startDate.getDate(),
    0,
    0,
    0,
    0
  );
  const end = new Date(
    endDate.getFullYear(),
    endDate.getMonth(),
    endDate.getDate(),
    23,
    59,
    59,
    999
  );
  return date >= start && date <= end;
}

export function countPlatformsForUsers(
  platformUsers: PlatformUserActivity[],
  startDate: Date,
  endDate: Date
): PlatformCounts {
  const counts: PlatformCounts = { web: 0, android: 0, ios: 0 };

  platformUsers.forEach((user) => {
    if (user.web) {
      const loginDate = new Date(user.web);
      if (isWithinRange(loginDate, startDate, endDate)) counts.web++;
    }
    if (user.android) {
      const loginDate = new Date(user.android);
      if (isWithinRange(loginDate, startDate, endDate)) counts.android++;
    }
    if (user.ios) {
      const loginDate = new Date(user.ios);
      if (isWithinRange(loginDate, startDate, endDate)) counts.ios++;
    }
  });

  return counts;
}

export function getRangeExportSlug(selection: number): string {
  if (selection === 90) return "last_quarter";
  if (selection === 365) return "last_year";
  return `${selection}_days`;
}
